<template>
  <div class="d-inline-block">
    <v-tooltip left content-class="tooltip-left">
      <template v-slot:activator="{ on, attrs }">
        <base-button
          icon-style
          small
          v-bind="attrs"
          v-on="on"
          :image="icon"
          :image-width="imageWidth"
          image-alt="Activity Log Icon"
          @click="dialog = true; loadData()"
        />
      </template>
      <span>View Activity Log</span>
    </v-tooltip>

    <lb-dialog
      v-model="dialog"
      :heading="heading"
      :width="width"
      :loading="loading"
    >
      <template v-slot:body>
        <div v-if="loglist.length" class="activity-log d-flex gap-6 flex-column" data-testid="activity-log__content">

          <div
            v-for="(v, k) in loglist"
            :key="k"
            class="activity-row"
          >
            <!-- LEFT TIME COLUMN -->
            <div class="time-col">
              <div class="time">
                {{ $nova.formatDateTime(new Date(v.created_at), 'hh:mm A') }}
              </div>
              <div class="date">
                {{ $nova.formatDateTime(new Date(v.created_at), 'DD MMM yyyy') }}
              </div>
            </div>

            <!-- TIMELINE -->
            <div class="timeline-col">
              <span class="dot"></span>
              <span
                v-if="k !== loglist.length - 1"
                class="line"
              ></span>
            </div>

            <!-- CONTENT CARD -->
            <div class="content-col d-flex flex-column gap-2">
              <div class="logtitle">
                {{ v.text || (config[v.type] || {}).displaytext || v.type }}
              </div>

              <div class="user-row">
                <v-tooltip bottom content-class="tooltip-bottom">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar
                      size="24"
                      color="primary"
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span class="white--text">
                        {{ ((v.userid_detail || {}).name || 'A')[0] }}
                      </span>
                    </v-avatar>
                  </template>
                  <span>{{ (v.userid_detail || {}).name }}</span>
                </v-tooltip>

                <div class="user-pill">
                  {{ (v.userid_detail || {}).contactemail }}
                </div>
              </div>
            </div>
          </div>

        </div>

        <div v-else class="empty">
          No Log Available
        </div>
      </template>
    </lb-dialog>
  </div>
</template>


<script>
import { formatVarianceActivityLogEntries } from '@/modules/varianceanalysis/utils/activityLogHelpers';

export default {
  data: function () {
    return {
      dialog: false,
      loading: false,
      loglist: [],
    };
  },
  // created() {
  //   this.refreshData();
  // },
  // activated() {
  //   this.refreshData();
  // },
  props: {
    heading: {
      type: String,
      default: "Activity Log",
    },
    icon: {
      type: String,
      default: "/img/icons/activity-log.svg",
    },
    imageWidth: {
      type: [Number, String],
      default: 16,
    },
    width: {
      type: String,
      default: "600",
    },
    url: {
      type: String,
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    contentClass: {
      type: String,
      default: "tooltip-bottom",
    },
    /** @type {Object} Optional filter object to pass with the API request */
    filter: {
      type: Object,
      default: () => ({}),
    },
    /** Reporting type for label remapping - 'bs' | 'pl' */
    reportingType: {
      type: String,
      default: '',
    },
  },
  methods: {
    getActivityLogFormatOptions() {
      return {
        reportingType: this.reportingType || this.filter?.reporting_type || this.filter?.reportingType || '',
        filter: this.filter,
        labelsName: this.$nova?.labelsName?.bind(this.$nova),
        identifyAndRemapLabelName: this.$nova?.identifyAndRemapLabelName?.bind(this.$nova),
      };
    },
    loadData() {
      this.loading = true;
      this.loglist = [];
      if (this.url) {
        this.$nova.apiGet.call(this, this.url, this.filter)
          .then((dt) => {
            if (dt.data.status === "success") {
              const rawLogs = Array.isArray(dt.data.data) ? dt.data.data : (Array.isArray(dt.data.data?.data) ? dt.data.data.data : []);
              this.loglist = formatVarianceActivityLogEntries(rawLogs, this.getActivityLogFormatOptions());
            } else throw new Error("Error loading information");
          })
          .catch((err) => {
            this.$store.commit(
              "sbError",
              err.message || err || "Unknown error!"
            );
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>

.activity-row {
  display: flex;
  align-items: stretch;
}

/* TIME COLUMN */
.time-col {
  width: 120px;
  text-align: right;
  padding-right: 12px;
}

.time {
  font-size: 14px;
  color: #828285;
}

.date {
  font-size: 14px;
  color: #828285;
}

/* TIMELINE */
.timeline-col {
  position: relative;
  width: 24px;
  display: flex;
  justify-content: center;
}

.timeline-col .dot {
  width: 8px;
  height: 8px;
  background: #9e9e9e;
  border-radius: 50%;
  margin-top: 4px;
  z-index: 2;
}

.timeline-col .line {
  position: absolute;
  top: 8px;
  width: 2px;
  height: calc(100% + 14px);
  background: #e0e0e0;
}

/* CONTENT */
.content-col {
  background: #f9fafb;
  border-radius: 8px;
  padding: 10px;
  flex: 1;
}

.logtitle {
  font-weight: 500;
  color: #2C2C35;
  font-size: 14px;
}

/* USER */
.user-row {
  display: flex;
  align-items: center;
}

.user-pill {
  border: 1px solid var(--grey-100);
  background: var(--grey-50) !important;
  padding: 4px 10px;
  border-radius: 14px;
  font-size: 12px;
  color: #2C2C35;
}

/* EMPTY */
.empty {
  text-align: center;
  color: #9e9e9e;
  padding: 32px;
}

</style>